import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { CmsData } from "@dotcom-frontend/data";
import { LgHeadingComponent } from "@legal-and-general/canopy";
import { WysiwygDirective } from "../../../directives/wysiwyg.directive";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";

@Component({
  selector: "dotcom-frontend-heading",
  templateUrl: "./Heading.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrl: "./Heading.component.scss",
  standalone: true,
  imports: [LgHeadingComponent, WysiwygDirective]
})
export class HeadingComponent implements DynamicComponent, OnInit {
  @Input() data: CmsData | undefined;
  title: string | undefined;
  subtitle: string | undefined;

  ngOnInit() {
    if (this.data && this.data["headingBlock"]) {
      this.title = this.data["headingBlock"]["headingTitle"];
      this.subtitle = this.data["headingBlock"]["headingSubTitle"];
    }
  }
}
